import { defineMessages } from 'react-intl';

// This contains all the translatable interface messages.
const messages = defineMessages({
  // Usable Storage
  usableStorageLabel: {
    id: '/FVcb4',
    defaultMessage: 'Usable storage amount',
  },
  usableStorageTooltip: {
    id: 'xoslG6',
    defaultMessage:
      'Select an amount of usable storage. Assumptions include: 85% capacity utilization, no compression/ deduplication, no overhead, and an optimized RAID level.',
  },
  // Performance Level
  performanceLevelLabel: {
    id: 'DtSkIn',
    defaultMessage: 'Performance level',
  },
  performanceLevelTooltip: {
    id: 'qsz8T1',
    defaultMessage:
      'Select your desired IOPS. Assumes 16K blocks, 70% read, 30% write. Actual performance may vary.',
  },
  liteLabel: {
    id: 'mM5Wzw',
    defaultMessage: 'Lite',
  },
  mediumLabel: {
    id: 'ovJ26C',
    defaultMessage: 'Medium',
  },
  highLabel: {
    id: 'AxMhQr',
    defaultMessage: 'High',
  },
  extremeLabel: {
    id: '/fAZ0s',
    defaultMessage: 'Extreme',
  },
  // Comparison table titles
  averageTitleLabel: {
    id: 'aSOfw0',
    defaultMessage: 'Industry Average',
  },
  averageTitleTooltip: {
    id: 'w7/3Q1',
    defaultMessage:
      'The average is calculated from equivalent storage configurations from 5 other leading storage vendors. Vendor and configuration adjustments available in full TCOgo! tool.',
  },
  // Variables to compare Industry and IBM
  driveNumberLabel: {
    id: 'gqz2+w',
    defaultMessage: 'Number of drives',
  },
  driveTypeLabel: {
    id: 'G+pfMQ',
    defaultMessage: 'Drive type',
  },
  rackUnityLabel: {
    id: 'd+A/eu',
    defaultMessage: 'Rack units',
  },
  carbonOutputLabel: {
    id: 'PQE3jJ',
    defaultMessage: 'Carbon output',
  },
  // Comparison variables tooltips
  driveNumberTooltip: {
    id: 'yk8NOA',
    defaultMessage:
      'The estimated total number of drives in the configuration.',
  },
  driveTypeTooltip: {
    id: 'lkHDW6',
    defaultMessage:
      'The primary drive type used in the configuration is based on the drives inside the control enclosure(s) (if applicable).',
  },
  rackUnityTooltip: {
    id: 'cXtflW',
    defaultMessage:
      'The estimated number of rack units based on the configuration.',
  },
  carbonOutputTooltip: {
    id: 'uiJ5Oy',
    defaultMessage:
      'The estimated amount of carbon saved based upon systems running 24/7/365. Typical usage is assumed and the PUE designated below is applied. The result is in metric tons of carbon dioxide.',
  },
  // Carbon output metric
  carbonOutputMetric: {
    id: 'DR8NTJ',
    defaultMessage: 'grams CO₂ per kWh',
  },
  // Resoureces saved section
  electricityCarbonLabel: {
    id: 'pj2gA7',
    defaultMessage: 'Total energy costs saved over 5 years',
  },
  savedTreeLabel: {
    id: 'ToiY0n',
    defaultMessage: 'Choosing IBM, you could save an estimated',
  },
  savedTreeLabelComplement: {
    id: 'LQvUDP',
    defaultMessage: 'trees',
  },
  //CIO View Table
  assumptionsTitle: {
    id: 'X3hl5x',
    defaultMessage: 'Assumptions',
  },
  // CIO View evaluated variables
  countrySelectionLabel: {
    id: '+WrtFE',
    defaultMessage: 'Select a country to see the defaults change',
  },
  countrySelectionTooltip: {
    id: 'BUEMi4',
    defaultMessage:
      'This information adjusts the currency, the default price of electricity, and the default carbon intensity.',
  },
  priceKWhLabel: {
    id: '/sRVtA',
    defaultMessage: 'Price per kWh',
  },
  priceKWhTooltip: {
    id: '/1HQ60',
    defaultMessage:
      'This is the default cost of electricity per kilowatt hour based upon the country you selected. Specific state defaults available in full TCOgo! tool.',
  },
  carbonIntensityLabel: {
    id: 'tQtJKp',
    defaultMessage: 'Carbon intensity',
  },
  carbonIntensityTooltip: {
    id: 'AIABl2',
    defaultMessage:
      'The selected country determines your carbon intensity. Power sources will produce varying amounts of carbon dioxide. Carbon intensity represents the average grams of carbon dioxide emitted to produce a kilowatt hour of electricity.',
  },
  PueFactorLabel: {
    id: '9iJhYD',
    defaultMessage: 'PUE factor',
  },
  PueFactorTooltip: {
    id: 'VP6G+T',
    defaultMessage:
      'PUE (power usage effectiveness) represents the electricity consumed above the power strictly needed to run your IT equipment. A rating of 1.85 means you use an additional 58% for cooling, lighting, network management, security, etc. Example values: very low 1.3, low 1.5, average 1.6, high 2+.',
  },
  // Carbon intesity metric
  carbonIntensityMetric: {
    id: 'DR8NTJ',
    defaultMessage: 'grams CO₂ per kWh',
  },

  // Countries data
  abuDhabi: {
    id: 'n96cvC',
    defaultMessage: 'Abu Dhabi',
  },
  afghanistan: {
    id: 'uWSAC7',
    defaultMessage: 'Afghanistan',
  },
  albania: {
    id: '90h7/c',
    defaultMessage: 'Albania',
  },
  algeria: {
    id: 'xrCy9R',
    defaultMessage: 'Algeria',
  },
  andorra: {
    id: 'WU4UUT',
    defaultMessage: 'Andorra',
  },
  angola: {
    id: 'sX2X1Y',
    defaultMessage: 'Angola',
  },
  antigua: {
    id: 'YE1l8T',
    defaultMessage: 'Antigua and Barbuda',
  },
  argentina: {
    id: 'wHkOq4',
    defaultMessage: 'Argentina',
  },
  aruba: {
    id: 'Y42Bah',
    defaultMessage: 'Aruba',
  },
  australia: {
    id: 'D4A2LZ',
    defaultMessage: 'Australia',
  },
  austria: {
    id: 'ZwXv1C',
    defaultMessage: 'Austria',
  },
  azerbaijan: {
    id: 'NDmBum',
    defaultMessage: 'Azerbaijan',
  },
  bahamas: {
    id: 'Vur4Pc',
    defaultMessage: 'Bahamas',
  },
  bahrain: {
    id: '/5cdjt',
    defaultMessage: 'Bahrain',
  },
  bangladesh: {
    id: 'gEWjsM',
    defaultMessage: 'Bangladesh',
  },
  barbados: {
    id: 'IC39KF',
    defaultMessage: 'Barbados',
  },
  belgium: {
    id: 'o5InVy',
    defaultMessage: 'Belgium',
  },
  belize: {
    id: 'dtDgwz',
    defaultMessage: 'Belize',
  },
  benin: {
    id: 'inFU+b',
    defaultMessage: 'Benin',
  },
  bermuda: {
    id: 'lNpHJU',
    defaultMessage: 'Bermuda',
  },
  bhutan: {
    id: 'MK2kPw',
    defaultMessage: 'Bhutan',
  },
  bolivia: {
    id: '6ZgBbw',
    defaultMessage: 'Bolivia',
  },
  bosnia: {
    id: 'IxV+TQ',
    defaultMessage: 'Bosnia and Herzegovina',
  },
  botswana: {
    id: '+hgjwh',
    defaultMessage: 'Botswana',
  },
  brazil: {
    id: 'zJ+Qdi',
    defaultMessage: 'Brazil',
  },
  britishVI: {
    id: '39y4D4',
    defaultMessage: 'British Virgin Islands',
  },
  brunei: {
    id: 'NYfs4P',
    defaultMessage: 'Brunei',
  },
  bulgaria: {
    id: 'uLjfHx',
    defaultMessage: 'Bulgaria',
  },
  burundi: {
    id: 'o+2sFT',
    defaultMessage: 'Burundi',
  },
  cambodia: {
    id: 'cB8Agh',
    defaultMessage: 'Cambodia',
  },
  cameroon: {
    id: 'ECeXar',
    defaultMessage: 'Cameroon',
  },
  canada: {
    id: '2abiy0',
    defaultMessage: 'Canada',
  },
  capeVerde: {
    id: 'H1Z6eb',
    defaultMessage: 'Cape Verde Islands',
  },
  caymanIslands: {
    id: '80nWOt',
    defaultMessage: 'Cayman Islands',
  },
  centralAfricanRepublic: {
    id: 'MjNTEu',
    defaultMessage: 'Central African Republic',
  },
  chad: {
    id: '6AXoVq',
    defaultMessage: 'Chad',
  },
  chile: {
    id: 'QtvgOo',
    defaultMessage: 'Chile',
  },
  china: {
    id: '1q/ois',
    defaultMessage: 'China',
  },
  colombia: {
    id: 'PZh7w+',
    defaultMessage: 'Colombia',
  },
  comoros: {
    id: 'zB+1uJ',
    defaultMessage: 'Comoros',
  },
  congo: {
    id: 'UG+zuN',
    defaultMessage: 'Congo',
  },
  congoDemRepublic: {
    id: 'RpJMaz',
    defaultMessage: 'Congo Dem. Republic',
  },
  costaRica: {
    id: 'HmnV8f',
    defaultMessage: 'Costa Rica',
  },
  croatia: {
    id: 'Evxi/h',
    defaultMessage: 'Croatia',
  },
  cyprus: {
    id: 'f51mrK',
    defaultMessage: 'Cyprus',
  },
  czechRepublic: {
    id: '+d/tNA',
    defaultMessage: 'Czech Republic',
  },
  denmark: {
    id: 'OjT4Gq',
    defaultMessage: 'Denmark',
  },
  dominica: {
    id: 'oQCGsZ',
    defaultMessage: 'Dominica',
  },
  dominicanRepublic: {
    id: 'XM2eiF',
    defaultMessage: 'Dominican Republic',
  },
  ecuador: {
    id: 'TkvM0N',
    defaultMessage: 'Ecuador',
  },
  egypt: {
    id: 'BIR9MS',
    defaultMessage: 'Egypt',
  },
  elSalvador: {
    id: 'lAqxac',
    defaultMessage: 'El Salvador',
  },
  equatorialGuinea: {
    id: 'A0QuW0',
    defaultMessage: 'Equatorial Guinea',
  },
  eritrea: {
    id: '4+tITf',
    defaultMessage: 'Eritrea',
  },
  estonia: {
    id: 'oM/Jlx',
    defaultMessage: 'Estonia',
  },
  ethiopia: {
    id: 'HkNqjk',
    defaultMessage: 'Ethiopia',
  },
  faroeIslands: {
    id: 'aZxVvE',
    defaultMessage: 'Faroe Islands',
  },
  fiji: {
    id: 'zSzTfC',
    defaultMessage: 'Fiji',
  },
  finland: {
    id: 'OIc/xw',
    defaultMessage: 'Finland',
  },
  france: {
    id: '9KADbj',
    defaultMessage: 'France',
  },
  frenchGuiana: {
    id: '5FAe7C',
    defaultMessage: 'French Guiana',
  },
  frenchPolynesia: {
    id: 'vzHYL7',
    defaultMessage: 'French Polynesia',
  },
  gabon: {
    id: 'elJBhI',
    defaultMessage: 'Gabon',
  },
  gambia: {
    id: '58SIKu',
    defaultMessage: 'Gambia',
  },
  georgia: {
    id: 'C/46Vz',
    defaultMessage: 'Georgia',
  },
  germany: {
    id: 'PGzyr2',
    defaultMessage: 'Germany',
  },
  ghana: {
    id: 'PJLOZK',
    defaultMessage: 'Ghana',
  },
  gibraltar: {
    id: 'Yn6mMH',
    defaultMessage: 'Gibraltar',
  },
  greece: {
    id: 'yil/vB',
    defaultMessage: 'Greece',
  },
  greenland: {
    id: 'sroDBL',
    defaultMessage: 'Greenland',
  },
  grenada: {
    id: 'Wyr8z1',
    defaultMessage: 'Grenada',
  },
  guadeloupe: {
    id: 'g12swr',
    defaultMessage: 'Guadeloupe',
  },
  guam: {
    id: 'ec+8jt',
    defaultMessage: 'Guam',
  },
  guatemala: {
    id: 'fApUje',
    defaultMessage: 'Guatemala',
  },
  guineaBissau: {
    id: 'Xt1oEM',
    defaultMessage: 'Guinea Bissau',
  },
  guyana: {
    id: 'y19xMJ',
    defaultMessage: 'Guyana',
  },
  haiti: {
    id: 'TTeL00',
    defaultMessage: 'Haiti',
  },
  honduras: {
    id: 'gI1AIL',
    defaultMessage: 'Honduras',
  },
  hongKong: {
    id: 'JFYhZv',
    defaultMessage: 'Hong Kong',
  },
  hungary: {
    id: 'T6CwRX',
    defaultMessage: 'Hungary',
  },
  iceland: {
    id: 'Yr+/el',
    defaultMessage: 'Iceland',
  },
  india: {
    id: 'i5dhvD',
    defaultMessage: 'India',
  },
  iran: {
    id: 'nzwRIp',
    defaultMessage: 'Iran',
  },
  iraq: {
    id: 'qAiQn0',
    defaultMessage: 'Iraq',
  },
  indonesia: {
    id: 'vQOevT',
    defaultMessage: 'Indonesia',
  },
  ireland: {
    id: 'fGxzwb',
    defaultMessage: 'Ireland',
  },
  israel: {
    id: 'vwXIZQ',
    defaultMessage: 'Israel',
  },
  italy: {
    id: 'VzQxqn',
    defaultMessage: 'Italy',
  },
  ivoryCoast: {
    id: 'UueyB1',
    defaultMessage: 'Ivory Coast',
  },
  jamaica: {
    id: 'QQFsPa',
    defaultMessage: 'Jamaica',
  },
  japan: {
    id: '3Rh+pv',
    defaultMessage: 'Japan',
  },
  jordan: {
    id: 'BoKhrr',
    defaultMessage: 'Jordan',
  },
  kazakhstan: {
    id: 'VMm7cd',
    defaultMessage: 'Kazakhstan',
  },
  kenya: {
    id: '6307RX',
    defaultMessage: 'Kenya',
  },
  kiribati: {
    id: 'rkGcmk',
    defaultMessage: 'Kiribati',
  },
  korea: {
    id: 'MZQYMV',
    defaultMessage: 'Korea',
  },
  kuwait: {
    id: 'g6e3dg',
    defaultMessage: 'Kuwait',
  },
  kyrgyzstan: {
    id: '+Im81x',
    defaultMessage: 'Kyrgyzstan',
  },
  laos: {
    id: 'FpzDjr',
    defaultMessage: 'Laos',
  },
  latvia: {
    id: 'mNdVd9',
    defaultMessage: 'Latvia',
  },
  lebanon: {
    id: 'tgKpK7',
    defaultMessage: 'Lebanon',
  },
  lesotho: {
    id: '4kjIFD',
    defaultMessage: 'Lesotho',
  },
  liberia: {
    id: 'ikBdCN',
    defaultMessage: 'Liberia',
  },
  libyanArabJamahiriya: {
    id: '/kIu4a',
    defaultMessage: 'Libyan Arab Jamahiriya',
  },
  liechtenstein: {
    id: '7HIoTU',
    defaultMessage: 'Liechtenstein',
  },
  lithuania: {
    id: 'pFuHho',
    defaultMessage: 'Lithuania',
  },
  luxembourg: {
    id: 'LhhU6X',
    defaultMessage: 'Luxembourg',
  },
  macau: {
    id: '6xSa54',
    defaultMessage: 'Macau',
  },
  macedonia: {
    id: 'ByhIs0',
    defaultMessage: 'Macedonia',
  },
  madagascar: {
    id: 'aNjcfm',
    defaultMessage: 'Madagascar',
  },
  malawi: {
    id: '/hi87u',
    defaultMessage: 'Malawi',
  },
  malaysia: {
    id: 'b7zond',
    defaultMessage: 'Malaysia',
  },
  maldives: {
    id: 'Q11y5F',
    defaultMessage: 'Maldives',
  },
  mali: {
    id: 'I73NDr',
    defaultMessage: 'Mali',
  },
  malta: {
    id: 'k8wgb4',
    defaultMessage: 'Malta',
  },
  martinique: {
    id: 'Bq2nwA',
    defaultMessage: 'Martinique',
  },
  mauritania: {
    id: 'sXmy5o',
    defaultMessage: 'Mauritania',
  },
  mauritius: {
    id: 'XBetJ4',
    defaultMessage: 'Mauritius',
  },
  mayotte: {
    id: '6SzqQV',
    defaultMessage: 'Mayotte',
  },
  mexico: {
    id: 'QXG+La',
    defaultMessage: 'Mexico',
  },
  moldova: {
    id: '8EnWa6',
    defaultMessage: 'Moldova',
  },
  monaco: {
    id: 'qXzX3N',
    defaultMessage: 'Monaco',
  },
  mongolia: {
    id: 'sxNj0/',
    defaultMessage: 'Mongolia',
  },
  montenegro: {
    id: 'nxY39E',
    defaultMessage: 'Montenegro',
  },
  montserrat: {
    id: 'MKz1Tv',
    defaultMessage: 'Montserrat',
  },
  morocco: {
    id: 's8wxd4',
    defaultMessage: 'Morocco',
  },
  mozambique: {
    id: 'A8elG+',
    defaultMessage: 'Mozambique',
  },
  myanmarBurma: {
    id: '0WsPRo',
    defaultMessage: 'Myanmar Burma',
  },
  namibia: {
    id: 'DYK0ve',
    defaultMessage: 'Namibia',
  },
  nepal: {
    id: 'tGuLQJ',
    defaultMessage: 'Nepal',
  },
  netherlands: {
    id: 'hT/s2i',
    defaultMessage: 'Netherlands',
  },
  netherlandsAntilles: {
    id: 'IVTfhE',
    defaultMessage: 'Netherlands Antilles',
  },
  newCaledonia: {
    id: 'HNQOND',
    defaultMessage: 'New Caledonia',
  },
  nicaragua: {
    id: 'IeYjFw',
    defaultMessage: 'Nicaragua',
  },
  niger: {
    id: 'uXZM4v',
    defaultMessage: 'Niger',
  },
  newZealand: {
    id: 'tcWR8m',
    defaultMessage: 'New Zealand',
  },
  nigeria: {
    id: 'uKVTE3',
    defaultMessage: 'Nigeria',
  },
  norway: {
    id: 'mdq/wu',
    defaultMessage: 'Norway',
  },
  oman: {
    id: 'uWzT/K',
    defaultMessage: 'Oman',
  },
  pakistan: {
    id: 'u5SBAU',
    defaultMessage: 'Pakistan',
  },
  panama: {
    id: '+c9FIk',
    defaultMessage: 'Panama',
  },
  papuaNewGuinea: {
    id: '/0qKds',
    defaultMessage: 'Papua New Guinea',
  },
  paraguay: {
    id: 'mNZnPy',
    defaultMessage: 'Paraguay',
  },
  peru: {
    id: '5+dpGU',
    defaultMessage: 'Peru',
  },
  philippines: {
    id: 'RRQ7fk',
    defaultMessage: 'Philippines',
  },
  poland: {
    id: 'SZjU9E',
    defaultMessage: 'Poland',
  },
  portugal: {
    id: '67jBS8',
    defaultMessage: 'Portugal',
  },
  puertoRico: {
    id: '52kdGd',
    defaultMessage: 'Puerto Rico',
  },
  qatar: {
    id: '331fBb',
    defaultMessage: 'Qatar',
  },
  republicOfDjibouti: {
    id: 'o1buYG',
    defaultMessage: 'Republic of Djibouti',
  },
  republicOfMoldova: {
    id: 'swP51y',
    defaultMessage: 'Republic of Moldova',
  },
  reunion: {
    id: '30Mg5/',
    defaultMessage: 'Reunion',
  },
  romania: {
    id: 'Jnm5JX',
    defaultMessage: 'Romania',
  },
  rwanda: {
    id: 'Co/5iq',
    defaultMessage: 'Rwanda',
  },
  saintKittsNevis: {
    id: 'VRg6av',
    defaultMessage: 'Saint Kitts And Nevis',
  },
  saintVincentGrenadines: {
    id: 'uCtOEJ',
    defaultMessage: 'Saint Vincent and Grenadines',
  },
  samoa: {
    id: 'tvE5JV',
    defaultMessage: 'Samoa',
  },
  sanMarino: {
    id: 'YaQUSr',
    defaultMessage: 'San Marino',
  },
  saoTomePrincipe: {
    id: 'A//js0',
    defaultMessage: 'Sao Tome and Principe',
  },
  saudiArabia: {
    id: 'cbMqh0',
    defaultMessage: 'Saudi Arabia',
  },
  senegal: {
    id: 'E902E8',
    defaultMessage: 'Senegal',
  },
  serbia: {
    id: 'fV65BM',
    defaultMessage: 'Serbia',
  },
  seychelles: {
    id: 'NAHlOT',
    defaultMessage: 'Seychelles',
  },
  sierraLeone: {
    id: 'mhcNvv',
    defaultMessage: 'Sierra Leone',
  },
  solomonIsland: {
    id: 'EN1ApP',
    defaultMessage: 'Solomon Island',
  },
  somalia: {
    id: 'NqFp7f',
    defaultMessage: 'Somalia',
  },
  singapore: {
    id: 'rhaGlx',
    defaultMessage: 'Singapore',
  },
  slovakia: {
    id: 'kkyKXY',
    defaultMessage: 'Slovakia',
  },
  slovenia: {
    id: 'LDo7Px',
    defaultMessage: 'Slovenia',
  },
  southAfrica: {
    id: 'XR8z3v',
    defaultMessage: 'South Africa',
  },
  spain: {
    id: 'GL9Msi',
    defaultMessage: 'Spain',
  },
  sriLanka: {
    id: 'tm3FzH',
    defaultMessage: 'Sri Lanka',
  },
  stLucia: {
    id: 'DVOsas',
    defaultMessage: 'St Lucia',
  },
  sudan: {
    id: 'VYWEFA',
    defaultMessage: 'Sudan',
  },
  sweden: {
    id: 'cOtCHW',
    defaultMessage: 'Sweden',
  },
  switzerland: {
    id: 'ERkh0f',
    defaultMessage: 'Switzerland',
  },
  syriaArabRepublic: {
    id: '/1iwiL',
    defaultMessage: 'Syria Arab Republic',
  },
  taiwan: {
    id: 'K283wu',
    defaultMessage: 'Taiwan',
  },
  tajikistan: {
    id: '2DrFi/',
    defaultMessage: 'Tajikistan',
  },
  tanzania: {
    id: 'Q23n/U',
    defaultMessage: 'Tanzania',
  },
  thailand: {
    id: 'dQZuWX',
    defaultMessage: 'Thailand',
  },
  togo: {
    id: 'DIFKwk',
    defaultMessage: 'Togo',
  },
  tonga: {
    id: 'xqD0n2',
    defaultMessage: 'Tonga',
  },
  trinidad: {
    id: 'Pyvg3m',
    defaultMessage: 'Trinidad',
  },
  tunisia: {
    id: 'Pyvg3m',
    defaultMessage: 'Trinidad',
  },
  turkey: {
    id: 'k/pu+/',
    defaultMessage: 'Turkey',
  },
  turkmenistan: {
    id: '884qo6',
    defaultMessage: 'Turkmenistan',
  },
  turksCaicosIslands: {
    id: 'FN5U0u',
    defaultMessage: 'Turks and Caicos Islands',
  },
  uganda: {
    id: '6TiqPJ',
    defaultMessage: 'Uganda',
  },
  ukraine: {
    id: '3T2iOg',
    defaultMessage: 'Ukraine',
  },
  unitedArabEmirates: {
    id: 'eMHa+3',
    defaultMessage: 'United Arab Emirates',
  },
  unitedKingdom: {
    id: 'SKtwiU',
    defaultMessage: 'United Kingdom',
  },
  unitedStates: {
    id: 'GZDSC0',
    defaultMessage: 'United States',
  },
  uruguay: {
    id: 'EbbVcC',
    defaultMessage: 'Uruguay',
  },
  uzbekistan: {
    id: 'IOia3K',
    defaultMessage: 'Uzbekistan',
  },
  vanuatu: {
    id: '/9BpZC',
    defaultMessage: 'Vanuatu',
  },
  vaticanCityState: {
    id: 'AAOpyU',
    defaultMessage: 'Vatican City State',
  },
  venezuela: {
    id: 'ZkjVLX',
    defaultMessage: 'Venezuela',
  },
  vietnam: {
    id: '+ieU8R',
    defaultMessage: 'Vietnam',
  },
  virginIslands: {
    id: 'RRF0Mk',
    defaultMessage: 'Virgin Islands US',
  },
  wallisFutunaIslands: {
    id: 'O1tw6H',
    defaultMessage: 'Wallis And Futuna Islands',
  },
  yemen: {
    id: 'EFE6ZV',
    defaultMessage: 'Yemen',
  },
  zambia: {
    id: 't50FYQ',
    defaultMessage: 'Zambia',
  },
  zimbabwe: {
    id: 'gaBIUj',
    defaultMessage: 'Zimbabwe',
  },
  // footnote
  footnote: {
    id: 'RZmMVF',
    defaultMessage:
      '*Capacity: 85% utilization, no compression/deduplication, no overhead. Performance: 16K blocks, 70% read, 30% write. Environment: running 24/7/365 with ambient temperature below 75F/25C.',
  },
});

export default messages;
